import Brightness4Icon from "@mui/icons-material/Brightness4";
import BrightnessHighIcon from "@mui/icons-material/BrightnessHigh";
import { AppBar, Avatar, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import { useGetIdentity } from "@refinedev/core";
import { HamburgerMenu, RefineThemedLayoutHeaderProps } from "@refinedev/mui";
import { useContext } from "react";
import { ColorModeContext } from "../contexts/colormode";

export const Header: React.FC<RefineThemedLayoutHeaderProps> = () => {

    const { data: user } = useGetIdentity();

    const { mode, setMode } = useContext(ColorModeContext);

    return (
        <AppBar
            color="default"
            position="sticky"
            elevation={0}
            sx={{
                "& .MuiToolbar-root": {
                    minHeight: "64px",
                },
                height: "64px",
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                backgroundColor: (theme) => theme.palette.background.paper,
            }}
        >
            <Toolbar
                sx={{
                    paddingLeft: {
                        xs: "16px",
                        md: "24px",
                    },
                }}
            >
                <HamburgerMenu />
                <Stack
                    direction="row"
                    width="100%"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={{
                        xs: "8px",
                        sm: "24px",
                    }}
                >
                    <Stack direction="row" flex={1} />
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={{
                            xs: "8px",
                            sm: "24px",
                        }}
                    >
                        <IconButton
                            onClick={() => {
                                setMode();
                            }}
                            sx={{
                                backgroundColor: (theme) =>
                                    theme.palette.mode === "dark" ? "transparent" : "#00000014",
                            }}
                        >
                            {mode === "dark" ? (
                                <BrightnessHighIcon />
                            ) : (
                                <Brightness4Icon
                                    sx={{
                                        fill: "#000000DE",
                                    }}
                                />
                            )}
                        </IconButton>

                        <Stack
                            direction="row"
                            gap={{
                                xs: "8px",
                                sm: "16px",
                            }}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Typography
                                fontSize={{
                                    xs: "12px",
                                    sm: "14px",
                                }}
                            >
                                {user?.name}
                            </Typography>
                            <Avatar src={user?.avatar} alt={user?.name} />
                        </Stack>
                    </Stack>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};
